import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
} from "@angular/core";

@Component({
  selector: "app-day-start-switcher",
  templateUrl: "./day-start-switcher.component.html",
  styleUrls: ["./day-start-switcher.component.scss"],
  standalone: false,
})
export class DayStartSwitcherComponent implements OnInit, OnChanges {
  @Input() primaryColor: string = "#75C2F6";
  @Input() primaryText: string = "";
  @Input() secondaryColor: string = "#8DADCC";
  @Input() secondaryText: string = "";
  @Input() currentState!: number; // Expected to be 0 or 1
  @Input() primaryDisabled: boolean = false;
  @Input() secondaryDisabled: boolean = false;
  @Input() isLoading: boolean = false;
  @Output() primaryEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() secondaryEvent: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild("switcherInput") switcherInput!: ElementRef<HTMLInputElement>;

  currentSlideState: number = 1; // Default state (1: on, 0: off)
  startX: number = 0;
  iconOffset: number = 0;
  isDragging: boolean = false;
  isDragSuccess: boolean = false;
  slider!: HTMLElement;
  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["currentState"]) {
      const previousValue = changes["currentState"].previousValue;
      const currentValue = changes["currentState"].currentValue;
   
      this.currentSlideState = currentValue;
      this.switcherInput &&
        (this.switcherInput.nativeElement.checked = !!currentValue);
      // initialize vars
      this.startX = 0;
      this.iconOffset = 0;
      this.isDragging = false;
      this.isDragSuccess = false;
      this.cdr.detectChanges();
    }
  }

  ngOnInit() {
    this.changeColor(this.primaryColor, this.secondaryColor);
  }

  startDrag(event: MouseEvent | TouchEvent) {
    this.isDragging = true;
    this.startX = this.getEventX(event);
    event.preventDefault(); // Prevent default to avoid other touch/click events
  }

  onDrag(event: MouseEvent | TouchEvent) {
    if (!this.isDragging) return;
    const switcherContainer = document.querySelector(
      ".switcher"
    ) as HTMLElement;
    const switcherWidth = switcherContainer.offsetWidth - 13;
    const currentX = this.getEventX(event);
    this.iconOffset = currentX - this.startX;
    if (this.iconOffset < 0 && this.currentSlideState === 0) {
      this.iconOffset = 0;
    } else if (this.iconOffset > 0 && this.currentSlideState === 1) {
      this.iconOffset = 0;
    }
    // Limit dragging within the boundaries of the container
    const maxDrag = switcherWidth; // Max drag distance in pixels
    if (this.iconOffset > maxDrag) this.iconOffset = maxDrag;
    if (this.iconOffset < -maxDrag) this.iconOffset = -maxDrag;

    // Update the position of the icon
    const icon = (event.target as HTMLElement).closest(".icon") as HTMLElement;
    this.slider = icon;
    if (icon) {
      icon.style.transform = `translateX(${this.iconOffset}px)`; // Move the icon based on the drag offset
    }
  }

  initSliderPosition(delay: number = 1000) {
    setTimeout(() => {
      this.slider.style.transform = `translateX(0px)`;
    }, delay);
  }

  endDrag(event: MouseEvent | TouchEvent) {
    if (!this.isDragging) return;

    const icon = (event.target as HTMLElement).closest(".icon") as HTMLElement;
    const switcherContainer = document.querySelector(
      ".switcher"
    ) as HTMLElement;

    if (icon && switcherContainer) {
      icon.style.transition = "transform 0.3s ease-out"; // Add smooth transition
      const switcherWidth = switcherContainer.offsetWidth - 13;
      const maxTranslateX = switcherWidth - icon.offsetWidth;
      if (this.iconOffset > switcherWidth / 2) {
        this.primaryEvent.emit();
        icon.style.transform = `translateX(${maxTranslateX}px)`;
        this.initSliderPosition();
        this.isDragSuccess = true;
      } else if (this.iconOffset < -(switcherWidth / 2)) {
        this.isDragSuccess = true;
        this.secondaryEvent.emit();
        icon.style.transform = `translateX(-${maxTranslateX}px)`;
        this.initSliderPosition(1000 * 1.5);
      } else {
        setTimeout(() => {
          if (icon) {
            this.isDragSuccess = false;
            icon.style.transform = "translateX(0px)";
          }
        }, 300); // Delay to allow transition to finish
      }
    }

    this.isDragging = false;
    this.iconOffset = 0;
  }

  // Utility to get the X coordinate of an event
  getEventX(event: MouseEvent | TouchEvent): number {
    if (event instanceof MouseEvent) {
      return event.clientX;
    } else if (event instanceof TouchEvent && event.touches.length > 0) {
      return event.touches[0].clientX;
    }
    return 0;
  }

  changeColor(primaryColor: string, secondaryColor: string) {
    const switcher = document.querySelector(".switcher-2") as HTMLElement;
    if (switcher) {
      switcher.style.setProperty("--primary-color", primaryColor);
      switcher.style.setProperty("--secondary-color", secondaryColor);
    }
  }
}
